'use strict'

// Dev is local Node (`NODE_ENV` unset, development, or test) and
// `SUPERTURBO_ENV` unset, `local` (the name start.sh uses), or one of those
// same names. Staging and production must be HTTPS.
// A reverse proxy sets `X-Forwarded-Proto` and must overwrite a client value.
// Loopback GET / and GET /health stay open so a process probe can run.

const { isLocalDev } = require('./cors-origins')

function httpsRequired (env) {

  return !isLocalDev(env)
}

function requestIsHttps (req) {

  if (!req) return false
  if (req.secure === true) return true

  const header = req.headers && req.headers['x-forwarded-proto']
  const proto = String(header || '').split(',')[0].trim().toLowerCase()

  return proto === 'https'
}

function loopbackHealth (req) {

  if (!req || req.method !== 'GET') return false
  if (req.path !== '/' && req.path !== '/health') return false

  const ip = (req.socket && req.socket.remoteAddress) || ''

  return ip === '127.0.0.1' || ip === '::1' || ip === '::ffff:127.0.0.1'
}

function httpsOnly (req, res, next) {

  if (!httpsRequired() || requestIsHttps(req) || loopbackHealth(req)) return next()

  res.status(403).type('text/plain').send('HTTPS is required.')
}

function insecurePage (location) {

  if (!location) return false

  const host = String(location.hostname || '').toLowerCase()

  if (host === 'localhost' || host === '127.0.0.1' || host === '::1' || host.endsWith('.localhost')) return false

  return String(location.protocol || '') !== 'https:'
}

function refuseInsecurePage (document, location) {

  if (!insecurePage(location)) return false

  if (document && document.documentElement) {

    document.documentElement.innerHTML = '<body><p>HTTPS is required.</p></body>'
  }

  return true
}

module.exports = {
  httpsRequired,
  requestIsHttps,
  loopbackHealth,
  httpsOnly,
  insecurePage,
  refuseInsecurePage
}
